const techs = {
    typescript: 'TypeScript',
    vue: 'Vue.js',
    python: 'Python3',
    kivy: 'Kivy',
    java: 'Java',
    swing: 'Swing',
    pythonGObject: 'PyGObject',
    gtk: 'GTK',
    netCore: '.NET Core',
    mvc: 'MVC',
    html: 'HTML5',
    scss: 'SCSS',
    c: 'C',
    csharp: 'C#',
    ncurses: 'ncurses',
    soap: 'SOAP',
    webService: 'Web service',
    web: 'Web',
    desktop: 'Desktop',
    cli: 'CLI',
    terminal: 'Terminal',
    node: 'Node.js',
    react: 'React',
    css: 'CSS',
    pwa: 'PWA',
    nest: 'NestJS',
};

export type SystemLinkType = 'github' | 'tryit' | 'none';


export interface Link {
    type: SystemLinkType;
    address: string;
}

export interface Project {
    name: string;
    description: string[];
    imgSrc?: string;
    customImgMaxWidth?: string;
    stack?: string[];
    links?: Link[];
}

export const projects: Project[] = [
    {
        name: 'Arkham Proxy',
        description: [
            'Collection manager and print workflow for Arkham cards, built for quick deck upkeep and proxy generation.',
            'Includes deck search, batch operations, and print-mode exports.',
        ],
        links: [
            { type: 'github', address: 'arkham-proxy' },
            { type: 'tryit', address: 'https://arkham.gcali.me/#' },
        ],
        imgSrc: require('../assets/arkham-proxy-showcase.png'),
        stack: [techs.csharp, techs.typescript, techs.react, techs.scss, techs.web],
    },
    {
        name: 'Bowling Solitaire',
        description: [
            'Play <a href=\'https://boardgamegeek.com/thread/1163813/sid-sacksons-bowling-solitaire-detailed-review\'>Bowling Solitaire</a> from Sid Sackson in your browser!',
            'Mobile friendly, no internet connection required, PWA support integrated',
        ],
        links: [
            { type: 'github', address: 'bowling-solitaire' },
            { type: 'tryit', address: 'https://gcali.me/bowling-solitaire' },
        ],
        imgSrc: require('../assets/bowling-solitaire.png'),
        stack: [techs.typescript, techs.vue, techs.html, techs.css, techs.pwa, techs.nest, techs.web],
    },
    {
        name: 'DodgeJS',
        description: ['Try and dodge as long as you can, now directly in your browser! Implemented without frameworks, vanilla TypeScript'],
        stack: [techs.typescript, techs.scss, techs.html, techs.web],
        imgSrc: require('../assets/dodgejs.png'),
        links: [
            { type: 'github', address: 'dodgejs' },
            { type: 'tryit', address: 'https://gcali.me/dodgejs' },
        ],
    },
    {
        name: 'AoC',
        description: [
            'Solver for the <a href=\'https://adventofcode.com/\'>Advent&nbsp;of&nbsp;Code</a>.',
            'Available both as a client only web app and as a stand alone CLI application',
        ],
        imgSrc: require('../assets/advent-tree.png'),
        customImgMaxWidth: '10em',
        links: [
            { type: 'github', address: 'aoc' },
            { type: 'tryit', address: 'https://gcali.me/aoc' },
        ],
        stack: [techs.typescript, techs.vue, techs.html, techs.scss, techs.web, techs.cli],
    },
    {
        name: 'Ts-Euler',
        description: [
            'Solver for <a href=\'https://projecteuler.net/\'>Project&nbsp;Euler</a>.',
        ],
        imgSrc: require('../assets/euler.png'),
        customImgMaxWidth: '10em',
        links: [
            { type: 'github', address: 'ts-euler' },
            { type: 'tryit', address: 'https://gcali.me/ts-euler' },
        ],
        stack: [techs.typescript, techs.vue, techs.html, techs.scss, techs.web, techs.cli],
    },
    {
        name: 'Duetto',
        description: [
            'Implementation of ' +
            '<a href="https://boardgamegeek.com/boardgame/224037/codenames-duet">Codenames: Duet</a> ' +
            'in a single page PWA with offline multiplayer.',
            'By choosing a common password, ' +
            'a custom random generator is seeded with the same data and lets users share ' +
            'the game table without internet connection!',
        ],
        stack: [techs.vue, techs.typescript, techs.pwa, techs.scss, techs.html],
        links: [
            {type: 'github', address: 'duetto'},
            {type: 'tryit', address: 'https://gcali.me/duetto'},
        ],
    },
    {
        name: 'Crucipixel',
        description: [
            'Solve <a href=\'https://en.wikipedia.org/wiki/Nonogram\'>crucipixels</a>' +
            ' (aka nonograms/picross) with this desktop application for Linux',
        ],
        imgSrc: require('../assets/crucipixel.png'),
        stack: [techs.python, techs.pythonGObject, techs.gtk, techs.desktop],
        links: [{ type: 'github', address: 'crucipixel' }],
    },
    {
        name: 'Minesweeper',
        description: [
            'Play minesweeper in your terminal!',
            'Simple implementation of the ubiquitous game of Minesweeper for a bash terminal,' +
            'complete of different board sizes and high score tracker',
        ],
        imgSrc: require('../assets/minesweeper.png'),
        stack: [techs.c, techs.ncurses, techs.terminal],
        links: [{ type: 'github', address: 'minesweeper' }],
    },
    {
        name: 'Dodge',
        description: ['Try and dodge as long as you can'],
        stack: [techs.python, techs.kivy, techs.desktop],
        imgSrc: require('../assets/dodge.png'),
        links: [{
            type: 'github',
            address: 'dodge',
        }],
    },
    {
        name: 'Jabyrinth',
        description: [
            'Labyrinth for the web!',
            'A custom implementation of the popular board game Labyrinth using TypeScript and Vue.js with a back end in .NET Core 3.1',
        ],
        stack: [techs.typescript, techs.vue, techs.html, techs.scss, techs.web, techs.netCore, techs.csharp],
        links: [{ type: 'github', address: 'jabyrinths' }],
    },
    {
        name: 'DO Automation',
        description: [
            'Scripts to simplify <a href=\'https://www.digitalocean.com\'>DigitalOcean</a> droplet management',
        ],
        stack: [techs.python, techs.cli],
        links: [{ type: 'github', address: 'do_automation' }],
    },
    {
        name: 'JHangman',
        description: [
            'Desktop application to play ' +
            '<a href=\'https://en.wikipedia.org/wiki/Hangman_(game)\'>Hangman</a>' +
            ' with friends in the same LAN through TCP/UDP',
        ],
        stack: [techs.java, techs.swing, techs.desktop],
        links: [{ type: 'github', address: 'jhangman' }],
    },
    {
        name: 'PTuring',
        description: [
            'Turing machine simulator for your command line',
            'CLI tool to simulate the turing machine, complete of parser and interpreter for a custom domain language',
        ],
        stack: [techs.python, techs.cli],
        links: [{ type: 'github', address: 'pturing' }],
    },
    {
        name: 'PlayEpisode',
        description: [
            'Never lose track of the next episode to watch!',
            'Simple tool for bash to keep track of a sequence of videos to play that lets you:' +
            '<ul>' +
            '<li>Play a video through an external player</li>' +
            '<li>Remember the last video played and automatically play the next one</li>' +
            '<li>Power down your pc if you fell asleep</li>' +
            '</ul>',
        ],
        stack: [techs.python, techs.ncurses, techs.terminal],
        links: [{ type: 'github', address: 'play_episode' }],
    },
    {
        name: 'LAI Boardgame',
        description: [
            'This one\'s for an old exam at my university;' +
            'simple client-server application to simulate a boardgame store',
        ],
        stack: [
            techs.java,
            techs.swing,
            techs.soap,
            techs.desktop,
            techs.webService,
        ],
        links: [{ type: 'github', address: 'laiboardgame' }],
    },
    {
        name: 'Ace2Ace',
        description: [
            'Web implementation of the card game \'Asso Asso\' with a SPA React front end and a Node.js based back-end',
        ],
        stack: [
            techs.node,
            techs.react,
            techs.web,
        ],
        links: [{ type: 'github', address: 'ace2ace' }],
    },
];
